export const FLAG_GETTING_TOLL_EXTRAORDINARY_ASSIGNMENTS =
  'FLAG_GETTING_TOLL_EXTRAORDINARY_ASSIGNMENTS';
export const GET_TOLL_EXTRAORDINARY_ASSIGNMENTS =
  'GET_TOLL_EXTRAORDINARY_ASSIGNMENTS';
export const CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENTS =
  'CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENTS';
export const FLAG_TOLL_EXTRAORDINARY_ASSIGNMENT_ACTIVITY =
  'FLAG_TOLL_EXTRAORDINARY_ASSIGNMENT_ACTIVITY';
export const GET_TOLL_EXTRAORDINARY_ASSIGNMENT =
  'GET_TOLL_EXTRAORDINARY_ASSIGNMENT';
export const CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENT =
  'CLEAR_TOLL_EXTRAORDINARY_ASSIGNMENT';
